import React from 'react';
import { MARQUEE_ITEMS } from '../data';
import './MarqueeStrip.css';

export default function MarqueeStrip({ variant = 'gold' }) {
  // Duplicate items for seamless loop
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];

  return (
    <div className={`marquee-strip marquee-strip--${variant}`}>
      <div className="marquee-track">
        <div className="marquee-inner">
          {items.map((item, i) => (
            <span key={i} className="marquee-item">
              <span className="marquee-dot" />
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
